import { ComponentType } from 'react';
import { hydrate } from 'react-dom';
import Loadable from 'react-loadable';
import { BrowserRouter } from 'react-router-dom';

import { SsrWrapper } from 'ssr/SsrWrapper';
import { ssrGetComponentContent } from 'ssr/ssrGetComponentContent';
import { SsrCreateStore } from 'ssr/types/SsrCreateStore';
import { SsrPayload } from 'ssr/types/SsrPayload';
import { bootstrapAnalytics } from 'utils/analytics/setup/bootstrapAnalytics';
import { initXMLHttpRequestActiveCounter } from 'utils/http';

import { SsrClientLocationHooks } from './SsrClientLocationHooks';
import { ssrClientLoadUserEnvironment } from './utils/ssrClientLoadUserEnvironment';
import { ssrClientPerformanceMark } from './utils/ssrClientPerformanceMark';

type Args = {
  payload: SsrPayload;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;
  createStore: SsrCreateStore;
};

export async function ssrClient({ payload, Component, createStore }: Args) {
  ssrClientPerformanceMark('Starting app');

  ssrClientPerformanceMark('Before waiting for loadables');
  await Loadable.preloadReady();
  ssrClientPerformanceMark('Done waiting for loadables');

  bootstrapAnalytics();

  // @ts-expect-error TS(2339): Property 'debugXhr' does not exist on type '{ init... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  if (window.Idealist && window.Idealist.debugXhr) {
    initXMLHttpRequestActiveCounter();
  }

  const {
    node,
    data: { state, config },
  } = payload;

  const store = createStore(state);
  const url = window.location.pathname;

  ssrClientPerformanceMark('Starting hydration');

  hydrate(
    <SsrWrapper store={store} config={config}>
      <BrowserRouter>
        <Component content={ssrGetComponentContent({ state, url })} />
        <SsrClientLocationHooks />
      </BrowserRouter>
    </SsrWrapper>,
    node,
    () => ssrClientPerformanceMark('App ready'),
  );

  ssrClientLoadUserEnvironment(store);
}
